export var MuiList = {
    styleOverrides: {},
    customOverrides: {
        topNav: {
            alignSelf: 'stretch',
            '& > *': {
                alignSelf: 'stretch',
            },
        },
        sideNav: {
            padding: 0,
        },
    },
};
